var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-header-wrapper",
    [
      _c(
        "a-card",
        [
          _c(
            "div",
            { staticClass: "table-page-search-wrapper" },
            [
              _c(
                "a-form",
                {
                  staticClass: "table-head-ground",
                  attrs: { layout: "inline" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "table-layer" },
                    [
                      _c(
                        "a-form-item",
                        {
                          staticClass: "table-head-layout",
                          staticStyle: {
                            "max-width": "520px",
                            "min-width": "400px",
                          },
                          attrs: { label: "" },
                        },
                        [
                          _c("time-range-filter", {
                            attrs: { "default-type": "today" },
                            on: { change: _vm.handleTimeRangeChange },
                          }),
                        ],
                        1
                      ),
                      _c("jeepay-text-up", {
                        attrs: {
                          placeholder: "转账/商户/渠道订单ID",
                          msg: _vm.searchData.unionOrderId,
                        },
                        model: {
                          value: _vm.searchData.unionOrderId,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchData, "unionOrderId", $$v)
                          },
                          expression: "searchData.unionOrderId",
                        },
                      }),
                      _c("jeepay-text-up", {
                        attrs: {
                          placeholder: "应用AppId",
                          msg: _vm.searchData.appId,
                        },
                        model: {
                          value: _vm.searchData.appId,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchData, "appId", $$v)
                          },
                          expression: "searchData.appId",
                        },
                      }),
                      _c(
                        "a-form-item",
                        {
                          staticClass: "table-head-layout",
                          attrs: { label: "" },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder: "转账状态",
                                "default-value": "",
                              },
                              model: {
                                value: _vm.searchData.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchData, "state", $$v)
                                },
                                expression: "searchData.state",
                              },
                            },
                            [
                              _c("a-select-option", { attrs: { value: "" } }, [
                                _vm._v("全部"),
                              ]),
                              _c("a-select-option", { attrs: { value: "0" } }, [
                                _vm._v("订单生成"),
                              ]),
                              _c("a-select-option", { attrs: { value: "1" } }, [
                                _vm._v("转账中"),
                              ]),
                              _c("a-select-option", { attrs: { value: "2" } }, [
                                _vm._v("转账成功"),
                              ]),
                              _c("a-select-option", { attrs: { value: "3" } }, [
                                _vm._v("转账失败"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        { staticClass: "table-page-search-submitButtons" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "search",
                                loading: _vm.btnLoading,
                              },
                              on: { click: _vm.queryFunc },
                            },
                            [_vm._v("搜索")]
                          ),
                          _c(
                            "a-button",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { icon: "reload" },
                              on: { click: () => (this.searchData = {}) },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c("JeepayTable", {
            ref: "infoTable",
            attrs: {
              initData: true,
              reqTableDataFunc: _vm.reqTableDataFunc,
              tableColumns: _vm.tableColumns,
              searchData: _vm.searchData,
              rowKey: "transferId",
              tableRowCrossColor: true,
            },
            on: {
              btnLoadClose: function ($event) {
                _vm.btnLoading = false
              },
            },
            scopedSlots: _vm._u([
              {
                key: "transferAmountSlot",
                fn: function ({ record }) {
                  return [_c("b", [_vm._v("₹" + _vm._s(record.amount))])]
                },
              },
              {
                key: "stateSlot",
                fn: function ({ record }) {
                  return [
                    _c(
                      "a-tag",
                      {
                        key: record.state,
                        attrs: {
                          color:
                            record.state === 0
                              ? "blue"
                              : record.state === 1
                              ? "orange"
                              : record.state === 2
                              ? "green"
                              : "volcano",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              record.state === 0
                                ? "订单生成"
                                : record.state === 1
                                ? "转账中"
                                : record.state === 2
                                ? "转账成功"
                                : record.state === 3
                                ? "转账失败"
                                : record.state === 4
                                ? "任务关闭"
                                : "未知"
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "orderSlot",
                fn: function ({ record }) {
                  return [
                    _c("div", { staticClass: "order-list" }, [
                      _c("p", [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#729ED5",
                              background: "#e7f5f7",
                            },
                          },
                          [_vm._v("转账")]
                        ),
                        _vm._v(_vm._s(record.transferId)),
                      ]),
                      _c(
                        "p",
                        { staticStyle: { "margin-bottom": "0" } },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#56cf56",
                                background: "#d8eadf",
                              },
                            },
                            [_vm._v("商户")]
                          ),
                          record.mchOrderNo.length > record.transferId.length
                            ? _c(
                                "a-tooltip",
                                {
                                  staticStyle: { "font-weight": "normal" },
                                  attrs: { placement: "bottom" },
                                },
                                [
                                  _c("template", { slot: "title" }, [
                                    _c("span", [
                                      _vm._v(_vm._s(record.mchOrderNo)),
                                    ]),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.changeStr2ellipsis(
                                          record.mchOrderNo,
                                          record.transferId.length
                                        )
                                      ) +
                                      " "
                                  ),
                                ],
                                2
                              )
                            : _c(
                                "span",
                                { staticStyle: { "font-weight": "normal" } },
                                [_vm._v(_vm._s(record.mchOrderNo))]
                              ),
                        ],
                        1
                      ),
                      record.channelOrderNo
                        ? _c(
                            "p",
                            {
                              staticStyle: {
                                "margin-bottom": "0",
                                "margin-top": "10px",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#fff",
                                    background: "#E09C4D",
                                  },
                                },
                                [_vm._v("渠道")]
                              ),
                              record.channelOrderNo.length >
                              record.transferId.length
                                ? _c(
                                    "a-tooltip",
                                    {
                                      staticStyle: { "font-weight": "normal" },
                                      attrs: { placement: "bottom" },
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _c("span", [
                                          _vm._v(_vm._s(record.channelOrderNo)),
                                        ]),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.changeStr2ellipsis(
                                              record.channelOrderNo,
                                              record.transferId.length
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                                    2
                                  )
                                : _c(
                                    "span",
                                    {
                                      staticStyle: { "font-weight": "normal" },
                                    },
                                    [_vm._v(_vm._s(record.channelOrderNo))]
                                  ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                },
              },
              {
                key: "opSlot",
                fn: function ({ record }) {
                  return [
                    _c(
                      "JeepayTableColumns",
                      [
                        _vm.$access("ENT_TRANSFER_ORDER_VIEW")
                          ? _c(
                              "a-button",
                              {
                                attrs: { type: "link" },
                                on: {
                                  click: function ($event) {
                                    return _vm.detailFunc(record.transferId)
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("TransferOrderDetail", { ref: "transferOrderDetail" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }